import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, Check, ShieldCheck, Compass } from 'lucide-react';
export function Pricing() {
  return <section id="oferta" className="py-24 bg-[#292524] text-white relative overflow-hidden" data-id="element-92">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-93">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#C5A059] blur-3xl" data-id="element-94"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-[#DFB76C] blur-3xl" data-id="element-95"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white/5 backdrop-blur-lg border border-[#C5A059]/30 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto mb-12" data-id="element-97">
          <h2 className="text-2xl md:text-3xl font-serif text-[#DFB76C] mb-8" data-id="element-98">
            RESUMEN DE TU TRANSFORMACIÓN
          </h2>

          <div className="mb-8 rounded-2xl overflow-hidden border border-white/10 shadow-2xl relative group" data-id="element-99">
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-100"></div>
            <img src="https://cdn.magicpatterns.com/uploads/61sVLyx5mtrXVR2J27mBqs/Imagen_preincipal.png" alt="Kit Completo El Código Invisible del Dinero" className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-101" />
          </div>

          <div className="space-y-5 mb-8 text-left bg-black/20 p-6 md:p-8 rounded-2xl border border-white/10" data-id="element-102">
            {/* Ebook */}
            <div className="flex justify-between items-center border-b border-white/10 pb-5" data-id="element-103">
              <div className="flex items-center gap-4" data-id="element-104">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-105">
                  <img src="https://cdn.magicpatterns.com/uploads/iWimrgztMff35AKnRwAAP8/Ebook_inicial.png" alt="Ebook" className="w-full h-full object-cover" data-id="element-106" />
                </div>
                <div data-id="element-107">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-108">
                    Ebook: El Código Invisible
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-109">
                    Sistema paso a paso para reprogramar tu patrón interno.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-110">
                <span className="text-stone-500 line-through text-xs block" data-id="element-111">
                  $27.00 USD
                </span>
                <span className="text-[#DFB76C] font-bold text-sm" data-id="element-112">
                  INCLUIDO
                </span>
              </div>
            </div>

            {/* Bono 1 */}
            <div className="flex justify-between items-center border-b border-white/10 pb-5" data-id="element-113">
              <div className="flex items-center gap-4" data-id="element-114">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-115">
                  <img src="https://cdn.magicpatterns.com/uploads/tHaUo3Q2fteRSt3z8qZjaH/Bonos_1.png" alt="Bono 1" className="w-full h-full object-cover" data-id="element-116" />
                </div>
                <div data-id="element-117">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-118">
                    Bono 1: Guionismo de Realidades
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-119">
                    Aprende a rediseñar tu narrativa interna y dejar de
                    sabotearte.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-120">
                <span className="text-stone-500 line-through text-xs block" data-id="element-121">
                  $15.00 USD
                </span>
                <span className="text-green-400 font-bold text-sm" data-id="element-122">GRATIS</span>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="flex justify-between items-center border-b border-white/10 pb-5" data-id="element-123">
              <div className="flex items-center gap-4" data-id="element-124">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-125">
                  <img src="https://cdn.magicpatterns.com/uploads/qBT1S5rWH7vN2jdgswgyYM/Bonos_2.png" alt="Bono 2" className="w-full h-full object-cover" data-id="element-126" />
                </div>
                <div data-id="element-127">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-128">
                    Bono 2: Mapa de los 5 Canales
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-129">
                    Crea múltiples fuentes de ingreso alineadas contigo.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-130">
                <span className="text-stone-500 line-through text-xs block" data-id="element-131">
                  $19.00 USD
                </span>
                <span className="text-green-400 font-bold text-sm" data-id="element-132">GRATIS</span>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="flex justify-between items-center pt-1" data-id="element-133">
              <div className="flex items-center gap-4" data-id="element-134">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-135">
                  <img src="https://cdn.magicpatterns.com/uploads/2o2rABF6mjBvDBGuDRLwtk/Bonos_3.png" alt="Bono 3" className="w-full h-full object-cover" data-id="element-136" />
                </div>
                <div data-id="element-137">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-138">
                    Bono 3: Billetera Magnética
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-139">
                    Checklist práctico para ordenar tu relación real con el
                    dinero.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-140">
                <span className="text-stone-500 line-through text-xs block" data-id="element-141">
                  $12.00 USD
                </span>
                <span className="text-green-400 font-bold text-sm" data-id="element-142">GRATIS</span>
              </div>
            </div>
          </div>

          <div className="mb-10 text-stone-300 text-sm md:text-base leading-relaxed max-w-lg mx-auto bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-143">
            <p data-id="element-144">
              El valor real de este sistema es de{' '}
              <strong className="text-white" data-id="element-145">$73 USD</strong>.
            </p>
            <p className="mt-2" data-id="element-146">
              Pero no estás pagando eso hoy. Este no es un precio 'normal'.{' '}
              <strong className="text-[#DFB76C]" data-id="element-147">
                Es una decisión estratégica para que puedas probarlo sin
                resistencia… y experimentar el cambio por ti misma.
              </strong>
            </p>
          </div>

          {/* MICRO-REFUERZO DE URGENCIA */}
          <div className="mb-8 text-center" data-id="element-148">
            <p className="text-red-400 font-medium italic mb-2" data-id="element-149">
              Este acceso no va a estar disponible a este precio por mucho
              tiempo.
            </p>
            <p className="text-stone-400 text-sm" data-id="element-150">
              Y lo sabes… las decisiones que cambian todo… rara vez esperan.
            </p>
          </div>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-151">
            <p className="text-stone-400 text-lg font-medium mb-1" data-id="element-152">
              Valor Total Real:
            </p>
            <p className="text-red-400/90 line-through decoration-red-500/60 text-5xl md:text-6xl font-bold mb-6" data-id="element-153">
              $73.00 USD
            </p>

            <div className="bg-[#C5A059]/10 border border-[#C5A059]/30 text-[#DFB76C] px-6 py-2 rounded-full text-sm md:text-base font-bold uppercase tracking-widest mb-4 shadow-[0_0_15px_rgba(197,160,89,0.2)]" data-id="element-154">
              Hoy accedes a todo por solo
            </div>

            <div className="flex items-baseline gap-2" data-id="element-155">
              <span className="text-7xl md:text-8xl font-bold text-white tracking-tighter drop-shadow-[0_0_25px_rgba(197,160,89,0.4)]" data-id="element-156">
                $6.39
              </span>
              <span className="text-2xl text-[#DFB76C] font-medium" data-id="element-157">USD</span>
            </div>
            <p className="text-stone-400 text-sm mt-2" data-id="element-158">
              Menos que un café. Pero con impacto real.
            </p>
          </div>

          <motion.a href="https://pay.hotmart.com/L105538443T" target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative w-full md:w-auto inline-flex items-center justify-center gap-3 px-8 py-5 text-lg font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_40px_rgba(197,160,89,0.3)] transition-all hover:shadow-[0_0_60px_rgba(197,160,89,0.5)]" data-id="element-159">
            <div className="absolute inset-0 gold-gradient" data-id="element-160"></div>
            <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-161"></div>
            <span className="relative flex items-center gap-2" data-id="element-162">
              👉 Quiero cambiar esto ahora
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-163" />
            </span>
          </motion.a>

          {/* HOW IT WORKS SECTION */}
          <div className="mt-16 mb-6 text-left bg-white/5 border border-white/10 rounded-2xl p-8 max-w-2xl mx-auto" data-id="element-164">
            <h3 className="text-xl font-serif text-[#DFB76C] mb-6 flex items-center gap-3" data-id="element-165">
              <Compass className="w-6 h-6" data-id="element-166" />
              ¿Qué pasa después de que entras?
            </h3>
            <ul className="space-y-5 text-stone-300" data-id="element-167">
              <li className="flex items-start gap-4" data-id="element-168">
                <div className="w-6 h-6 rounded-full bg-[#C5A059]/20 flex items-center justify-center shrink-0 mt-0.5 border border-[#C5A059]/30" data-id="element-169">
                  <span className="text-[#DFB76C] text-xs font-bold" data-id="element-170">1</span>
                </div>
                <span data-id="element-171">Recibes acceso inmediato</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-172">
                <div className="w-6 h-6 rounded-full bg-[#C5A059]/20 flex items-center justify-center shrink-0 mt-0.5 border border-[#C5A059]/30" data-id="element-173">
                  <span className="text-[#DFB76C] text-xs font-bold" data-id="element-174">2</span>
                </div>
                <span data-id="element-175">Lees el sistema (60 min aprox.)</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-176">
                <div className="w-6 h-6 rounded-full bg-[#C5A059]/20 flex items-center justify-center shrink-0 mt-0.5 border border-[#C5A059]/30" data-id="element-177">
                  <span className="text-[#DFB76C] text-xs font-bold" data-id="element-178">3</span>
                </div>
                <span data-id="element-179">Aplicas el primer ejercicio ese mismo día</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-180">
                <div className="w-6 h-6 rounded-full bg-[#C5A059]/20 flex items-center justify-center shrink-0 mt-0.5 border border-[#C5A059]/30" data-id="element-181">
                  <span className="text-[#DFB76C] text-xs font-bold" data-id="element-182">4</span>
                </div>
                <span data-id="element-183">Empiezas a notar cambios en cómo piensas y decides</span>
              </li>
            </ul>
          </div>
        </motion.div>

        {/* 11. GARANTÍA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-2xl mx-auto bg-gradient-to-r from-[#1C1917] via-[#292524] to-[#1C1917] border border-[#C5A059]/40 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-6 text-left shadow-xl" data-id="element-184">
          <div className="w-20 h-20 shrink-0 rounded-full bg-[#C5A059]/10 flex items-center justify-center border border-[#C5A059]/30" data-id="element-185">
            <ShieldCheck className="w-10 h-10 text-[#DFB76C]" data-id="element-186" />
          </div>
          <div data-id="element-187">
            <h3 className="text-xl font-serif font-bold text-[#DFB76C] mb-2" data-id="element-188">
              Garantía Incondicional de 7 Días
            </h3>
            <p className="text-stone-300 text-sm leading-relaxed mb-4" data-id="element-189">
              Pruébalo durante 7 días. Si no sientes un cambio real en cómo
              percibes el dinero… te devolvemos el 100%.{' '}
              <strong className="text-white" data-id="element-190">Sin preguntas.</strong>
            </p>
            <p className="text-[#DFB76C] font-medium text-sm italic border-t border-white/10 pt-4" data-id="element-191">
              No pierdes nada al probarlo… pero podrías perder mucho más si
              sigues igual.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}